// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    incidents: {
      label: 'Incidencias',
      help: 'Una fila por incidencia: qué pasó, sobre qué, cuándo y cuánto tardó en resolverse',
    },
    dates: {
      reported: 'Fecha en que pasó',
      resolved: 'Fecha de resolución',
      created: 'Fecha de alta',
    },
    metrics: {
      incidents: 'Incidencias',
      open: 'Sin resolver',
      critical: 'Críticas',
      blocking: 'Que paran el trabajo',
      resolved: 'Resueltas',
      dismissed: 'Descartadas',
      hoursToClose: 'Horas hasta resolver',
      realRate: 'Porcentaje reales',
    },
    dimensions: {
      type: 'Tipo',
      severity: 'Gravedad',
      status: 'Estado',
      subjectType: 'Tipo de cosa',
      subject: 'Sobre qué',
      assignee: 'Responsable',
      reporter: 'Quien lo vio',
      blocking: 'Para el trabajo',
    },
  },

  ca: {
    incidents: {
      label: 'Incidències',
      help: 'Una fila per incidència: què va passar, sobre què, quan i quant va tardar a resoldre’s',
    },
    dates: {
      reported: 'Data en què va passar',
      resolved: 'Data de resolució',
      created: 'Data d’alta',
    },
    metrics: {
      incidents: 'Incidències',
      open: 'Sense resoldre',
      critical: 'Crítiques',
      blocking: 'Que aturen la feina',
      resolved: 'Resoltes',
      dismissed: 'Descartades',
      hoursToClose: 'Hores fins a resoldre',
      realRate: 'Percentatge reals',
    },
    dimensions: {
      type: 'Tipus',
      severity: 'Gravetat',
      status: 'Estat',
      subjectType: 'Tipus de cosa',
      subject: 'Sobre què',
      assignee: 'Responsable',
      reporter: 'Qui ho va veure',
      blocking: 'Atura la feina',
    },
  },

  en: {
    incidents: {
      label: 'Incidents',
      help: 'One row per incident: what happened, what it was about, when, and how long it took',
    },
    dates: {
      reported: 'Date it happened',
      resolved: 'Date resolved',
      created: 'Date logged',
    },
    metrics: {
      incidents: 'Incidents',
      open: 'Unresolved',
      critical: 'Critical',
      blocking: 'Stopping work',
      resolved: 'Resolved',
      dismissed: 'Dismissed',
      hoursToClose: 'Hours to resolve',
      realRate: 'Real incidents',
    },
    dimensions: {
      type: 'Kind',
      severity: 'Severity',
      status: 'State',
      subjectType: 'Kind of thing',
      subject: 'About',
      assignee: 'Owner',
      reporter: 'Reported by',
      blocking: 'Stops work',
    },
  },

  fr: {
    incidents: {
      label: 'Incidents',
      help: 'Une ligne par incident : ce qui est arrivé, sur quoi, quand et en combien de temps',
    },
    dates: {
      reported: 'Date de l’incident',
      resolved: 'Date de résolution',
      created: 'Date de saisie',
    },
    metrics: {
      incidents: 'Incidents',
      open: 'Non résolus',
      critical: 'Critiques',
      blocking: 'Qui arrêtent le travail',
      resolved: 'Résolus',
      dismissed: 'Écartés',
      hoursToClose: 'Heures pour résoudre',
      realRate: 'Pourcentage réels',
    },
    dimensions: {
      type: 'Type',
      severity: 'Gravité',
      status: 'État',
      subjectType: 'Type de chose',
      subject: 'Concerne',
      assignee: 'Responsable',
      reporter: 'Signalé par',
      blocking: 'Arrête le travail',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
